import { useState } from "react";
import Layout from "src/components/layout";
import { Button } from "src/components/ui/button";
import { ComboboxForm } from "src/components/ui/combobox";
import { Input } from "src/components/ui/input";
import { Textarea } from "src/components/ui/textarea";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleCountryChange = (countryName: string) => {
    setFormData((prev) => ({ ...prev, country: countryName }));
  };

  const validateForm = () => {
    const errors: string[] = [];

    if (!formData.name.trim()) errors.push("Your Name");

    if (!formData.country) errors.push("Country");

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!formData.email || !emailRegex.test(formData.email)) {
      errors.push("Email");
    }

    if (!formData.message.trim()) errors.push("Message");

    return errors;
  };

  const handleSubmitForm = async () => {
    const errors = validateForm();

    if (errors.length > 0) {
      alert(`Please check the following fields: ${errors.join(", ")}.`);
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        to: "info@mardiin.com", //correo receptor del formulario
        templateId: "d-edd612d0e5ab4797abe8688414b2c82b",
        dynamicData: {
          nombre: formData.name,
          pais: formData.country,
          mensaje: formData.message,
          correo: formData.email,
          asunto: "Recibiste un correo de contacto",
        },
      };

      const response = await fetch(
        "https://mailing.thetecwave.com/api/v1/mail/send-dynamic-template",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("There was a problem sending the form");
      }

      alert("Message sent! We have received your message and will contact you soon.");

      // Reset form
      setFormData({
        name: "",
        country: "",
        email: "",
        message: "",
      });
    } catch {
      alert("There was a problem sending the form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout>
      <div className="bgHeroBanner">
        <div className="grid grid-cols-[2fr_5fr] md:grid-cols-[2fr_4fr] gap-4 px-3 max-w-[1400px] mx-auto py-[5%] items-center">
          <div className="mt-14 mx-auto max-w-[1400px] lg:flex lg:gap-9">
            <div className="[&>img]:mb-5 md:[&>img]:w-[150px]">
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/ElSalvador.webp")}
                alt="El Salvador"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Panama.webp")}
                alt="Panama"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Honduras.webp")}
                alt="Honduras"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Nicaragua.webp")}
                alt="Nicaragua"
              />
            </div>
            <div className="[&>img]:mb-5 lg:mt-9 md:[&>img]:w-[150px]">
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Belize.webp")}
                alt="Belize"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Guatemala.webp")}
                alt="Guatemala"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/CostaRica.webp")}
                alt="Costa Rica"
              />
            </div>
          </div>
          <div className="text-white mt-14 lg:flex lg:gap-6">
            <h1 className="text-4xl font-bold max-w-min">Contact Us</h1>
            <div>
              <p className="mt-8 lg:mt-20 w-[80%]">
                Do you have a question? We're here to help. Send us a message
                and we'll be in contact
              </p>

              <div className="flex flex-col gap-6 justify-center mt-4 max-w-[800px]">
                <Input
                  id="name"
                  type="text"
                  className="bg-[#515151] bg-opacity-80 border-none h-16 sm:w-[90%] min-w-[200px] placeholder:text-left placeholder:text-white"
                  placeholder="YOUR NAME"
                  value={formData.name}
                  onChange={handleInputChange}
                />
                <ComboboxForm onCountryChange={handleCountryChange} />
                <Input
                  id="email"
                  type="email"
                  className="bg-[#515151] bg-opacity-80 border-none h-16 sm:w-[90%] min-w-[200px] placeholder:text-left placeholder:text-white"
                  placeholder="EMAIL"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                <Textarea
                  id="message"
                  className="bg-[#515151] bg-opacity-80 h-[120px] sm:h-[300px] border-none sm:w-[90%] min-w-[200px] placeholder:text-left placeholder:text-white"
                  placeholder="YOUR MESSAGE HERE"
                  value={formData.message}
                  onChange={handleInputChange}
                />
                <Button
                  className="h-16 sm:w-[90%] font-extrabold"
                  onClick={handleSubmitForm}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "SENDING..." : "SEND"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
